module.exports = __webpack_public_path__ + "public/images/slider/vebber.f05648417e3caa89c26ea7c4a3c3a334.webp";